import { assembleCopyContent, assembleArticleCopyContent } from "./copy-helper";

export const copyHandler = async ({
    event,
    selectedText,
    highlightAreas,
    project,
    documentId,
    articleId,
    stage,
    articleType,
}) => {
    // Only handle copy if there's an active PDF text selection
    if (!highlightAreas?.length || (event && !selectedText)) {
        return;
    }

    // Prevent default event
    event && event.preventDefault();

    const area = {};
    let areaRight = 0;
    let areaBottom = 0;

    for (const hl of highlightAreas) {
        area.pageIndex = area.pageIndex ?? hl.pageIndex;

        if (!area.left || area.left > hl.left) {
            area.left = hl.left;
        }

        if (!area.top || area.top > hl.top) {
            area.top = hl.top;
        }

        let hlRight = hl.left + hl.width;
        if (!areaRight || hlRight > areaRight) {
            areaRight = hlRight;
        }

        let hlBottom = hl.top + hl.height;
        if (!areaBottom || hlBottom > areaBottom) {
            areaBottom = hlBottom;
        }
    }

    area.width = areaRight - area.left;
    area.height = areaBottom - area.top;

    const areaJson = JSON.stringify(area);

    let html = selectedText;
    if (articleId && project) {
        html = assembleArticleCopyContent({
            articleId,
            project,
            stage,
            articleType,
            content: selectedText,
            area: areaJson,
        });
    } else if (documentId && project) {
        html = assembleCopyContent({
            references: [{ documentId, area: areaJson }],
            project,
            content: selectedText,
        });
    }

    const data = {};
    data["text/plain"] = selectedText;
    data["text/html"] = html;

    // Use the modern clipboard API for consistency with the onCopy function
    try {
        const clipboardData = {};
        clipboardData["text/plain"] = new Blob([data["text/plain"]], { type: "text/plain" });
        clipboardData["text/html"] = new Blob([data["text/html"]], { type: "text/html" });

        await navigator.clipboard.write([new window.ClipboardItem(clipboardData)]);
    } catch (error) {
        // Fallback to the event clipboardData if modern API fails
        const clipboardData = event?.clipboardData || window.clipboardData;

        clipboardData.setData("text/plain", data["text/plain"]);
        clipboardData.setData("text/html", data["text/html"]);
    }
};
